import { useEffect, useMemo } from 'react';
import './Dashboard.scss';
import { Typography, Col, Row } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import Loader from "../../components/CustomLoader/Loader";
import CreditLimitChart from './Components/CreditLimitChart';
import CreditLimitBreakup from './Components/CreditLimitBreakup';
import NewDeals from './Components/NewDeals';
import { getBusinesUsers, getBusActiveDeals } from "../../redux/slices/dashboardSlice";
import { GLOBAL_CONSTANTS } from '../../constants/constants';


const { Title } = Typography;

const Dashboard = () => {
  const busUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("busUser"));
    } catch {
      return null;
    }
  })();
  const { businessUser, newdeals, loading } = useSelector((state) => state?.dashboard);
  const activeCategory = useSelector((state) => state.dealCategory?.activeCategory);
  const user = useSelector((state) => state.auth?.user);
  const onboardingStepStatus = useSelector((state) => state.questionnaire?.onboardingStepStatus);
  const dispatch = useDispatch();

  const currentDealCategoryId =
    activeCategory?.dealCategoryId ||
    user?.dealCategories?.[0]?.dealCategoryId ||
    busUser?.dealCategories?.[0]?.dealCategoryId ||
    "DCT1000001";

  useEffect(() => {
    if (busUser?.orgId) {
      dispatch(getBusinesUsers({ orgId: busUser.orgId, dealCategoryId: currentDealCategoryId }));
      dispatch(getBusActiveDeals(busUser.orgId));
    }
  }, [busUser?.orgId, currentDealCategoryId, dispatch]);

  const isBusinessActive = useMemo(() => {
    const currentCategory =
      activeCategory ||
      user?.dealCategories?.[0] ||
      busUser?.dealCategories?.[0];

    const statusId =
      currentCategory?.statusId ||
      user?.statusId ||
      busUser?.statusId;

    const statusName = (
      currentCategory?.statusName ||
      user?.statusName ||
      user?.status ||
      busUser?.statusName ||
      busUser?.status ||
      ""
    ).toString().trim().toUpperCase();

    // Check if explicitly Pending
    if (
      statusId === GLOBAL_CONSTANTS.STAT_PEN_ID ||
      statusId === GLOBAL_CONSTANTS.STAT_KYC_PEN_ID ||
      statusId === GLOBAL_CONSTANTS.STAT_KYC_REVIEW_ID ||
      statusName === "PENDING" ||
      statusName === "KYC_PENDING" ||
      statusName === "KYC PENDING" ||
      statusName === "PENDING CREDIT LIMIT" ||
      onboardingStepStatus?.Business_Active === false
    ) {
      return false;
    }

    // Check if explicitly Active
    if (
      statusId === GLOBAL_CONSTANTS.STAT_ACTIVE_ID ||
      statusName === "ACTIVE" ||
      onboardingStepStatus?.Business_Active === true
    ) {
      return true;
    }

    return true;
  }, [activeCategory, user, busUser, onboardingStepStatus]);

  return (
    <>
      {loading ? <Loader /> : (
        <>
          <Row gutter={[16, 16]}>
            <Col xs={24} lg={isBusinessActive ? 8 : 12}>
              <Title level={3} style={{ margin: 0, fontSize: 24 }}>
                Credit Limit
              </Title>
              <CreditLimitChart businessUser={businessUser} dealCategoryId={currentDealCategoryId} />
            </Col>
            {isBusinessActive && (
              <Col xs={24} lg={16}>
                <Title level={3} style={{ margin: 0, fontSize: 24 }}>
                  Credit Limit Breakup
                </Title>
                <CreditLimitBreakup businessUser={businessUser} dealCategoryId={currentDealCategoryId} />
              </Col>
            )}
          </Row>
          <Title level={3} style={{ marginTop: 30, fontSize: 24 }}>
            Deals
          </Title>
          <NewDeals newdeals={newdeals} />
        </>
      )}
    </>
  );
};

export default Dashboard;
